<template>
  <div class="inputs-group">
    <div v-if="title" class="inputs-group__title" :class="{ 'mb-1': !!slots.subtitle }">
      {{ title }}
      <span v-if="required" class="text-red">*</span>
    </div>
    <template v-if="slots.subtitle">
      <div class="paragraph-s_h text-secondary" :class="{ 'mb-4': !!!noMarginBottom }">
        <slot name="subtitle" />
      </div>
    </template>
    <div class="inputs-group__content" :class="{ 'narrow-gap': !!narrowGap }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  required?: boolean;
  noMarginBottom?: boolean;
  narrowGap?: boolean;
}>();

const slots = defineSlots<{
  subtitle: () => void;
  default: () => void;
}>();
</script>

<style lang="scss" scoped>
.inputs-group {
  &__title {
    margin-bottom: 16px;

    @include paragraph-m_h();

    font-weight: 600;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 16px 24px;

    &.narrow-gap {
      column-gap: 5px;
    }
  }

  :deep(.inputs-group__tiny-input) {
    width: 100%;
    max-width: 280px;
  }
}
</style>
